import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ResourceManager from '@/Management/ResourceManager';
import type { IComparisonControlViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';

export default class ComparisonControlViewModel extends ControlViewModel {
    protected ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

    protected value: KnockoutObservable<any>;
    protected displayValue: KnockoutObservable<string>;
    protected comparisonValue: KnockoutObservable<any>;
    protected comparisonDisplayValue: KnockoutObservable<string>;

    protected isEqual: KnockoutObservable<boolean>;

    public comparisonIconViewModel: ImageViewModelT;

    constructor(params: IComparisonControlViewModelConstructorParameter) {
        super(params);

        this.value = params.value;
        this.displayValue = params.displayValue;
        this.comparisonValue = params.comparisonValue;
        this.comparisonDisplayValue = params.comparisonDisplayValue;

        this.isEqual = this.createIsEqualComputed();
        this.comparisonIconViewModel = this.createComparisonIcon();
    }

    protected createIsEqualComputed(): KnockoutComputed<boolean> {
        return this.defineComputed(() => {
            const value = this.value();
            const comparisonValue = this.comparisonValue();
            return value == comparisonValue;
        });
    }

    protected createComparisonIcon(): ImageViewModelT {
        return new this.ImageViewModel({
            source: this.createComparisonIconSource(),
            tooltip: new this.LabelViewModel({
                caption: this.defineComputed(() => {
                    const isEqual = this.isEqual();
                    const comparisonValue = this.comparisonDisplayValue();
                    return isEqual ? null : this.getComparisonTooltipContent(comparisonValue);
                })
            })
        });
    }

    protected createComparisonIconSource(): KnockoutObservable<string> {
        return this.defineComputed(() => this.isEqual() ? 'comparison-equal.svg' : 'comparison-different.svg');
    }

    protected getComparisonTooltipContent(comparisonValue: string): string {
        const resource = ResourceManager.getInstance().get('COMPARISONCONTROL.COMPARISON_VALUE');
        return resource.replace('$$comparisonValue$$', comparisonValue ?? '-');
    }
}

ComponentManager.setViewModel('ComparisonControl', ComparisonControlViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');